import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConnectionStatusService } from '../../../services/connection-status.service';

@Component({
  selector: 'app-connection-banner',
  templateUrl: './connection-banner.component.html',
  styleUrls: ['./connection-banner.component.scss'],
})
export class ConnectionBannerComponent implements OnInit, OnDestroy {
  isDown = false;
  private sub: Subscription;

  constructor(private connectionStatusService: ConnectionStatusService) {}

  ngOnInit(): void {
    this.sub = this.connectionStatusService.isBackendDown$.subscribe((isDown) => {
      this.isDown = isDown;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
